import { Alert, Button, ButtonSize } from '@unmind/design-system';
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

import { getChannel } from 'utils';

import { ICounsellor, TType, TSessionPrep } from '../../types';
import { Wrapper } from './styles';

export interface Props {
  counsellor?: ICounsellor;
  type: TType;
  sessionPrep?: TSessionPrep;
}

export default ({ counsellor, type, sessionPrep }: Props) => {
  const { t } = useTranslation('book');
  const { supportUrl } = getChannel();

  return (
    <Wrapper className="status">
      {type === 'request' && (
        <Trans
          t={t}
          i18nKey="sessionDetails.request"
          // eslint-disable-next-line jsx-a11y/anchor-has-content
          components={[<a href={supportUrl} />]}
          values={{
            name: counsellor?.name,
            firstName: counsellor?.firstName || counsellor?.name,
          }}
        />
      )}

      {type === 'appointment' &&
        sessionPrep &&
        (sessionPrep.isCompleted || sessionPrep.url) && (
          <Alert
            className="alert no-border"
            variant={sessionPrep.isCompleted ? 'success' : 'warning'}
            size="small"
            title={t(
              `sessionDetails.appointment.sessionPrep.${
                sessionPrep.isCompleted ? 'complete' : 'incomplete.text'
              }`,
            )}
          >
            {sessionPrep.isCompleted ? (
              <></>
            ) : (
              <Button
                className="cta"
                variant="primary"
                size={ButtonSize.small}
                label={t(
                  'sessionDetails.appointment.sessionPrep.incomplete.cta',
                )}
                to={sessionPrep.url}
                {...{
                  target: '_blank',
                }}
              />
            )}
          </Alert>
        )}
    </Wrapper>
  );
};
